import * as React from "react"
import { useState } from "react"
import { PaginationType, SMSTemplatedType } from "@/types"
import { useQuery } from "@tanstack/react-query"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { useReactToPrint } from "react-to-print"

import { canViewThisPage } from "@/lib/api/auth"
import { getSMSTemplatedMessages } from "@/lib/api/templated-messages"
import { Button } from "@/components/ui/button"
import { DataTable } from "@/components/data-table"
import { Header } from "@/components/header"
import { Icons } from "@/components/icons"
import { smsTemplatedColumns } from "@/components/table/columns/sms-templated-columns"
import { ExportOperationModal } from "@/components/table/operations/export-operations"

import AddSMSPage from "./add"

export const Route = createFileRoute("/_home/message-templates/sms/")({
  beforeLoad: () => {
    if (canViewThisPage("himo_billing.view_smstemplatedmessage")) {
      return
    }

    return redirect({ to: "/access-denied" })
  },
  component: SmsTemplatedPage,
})

function SmsTemplatedPage() {
  const [showExportModal, setShowExportModal] = React.useState<boolean>(false)
  const [zones, setZones] = React.useState<number[]>([])
  const [search, setSearch] = useState<string>("")
  const [defaultPage, setDefaultPage] = useState<number>(10)
  const [page, setPage] = useState<number>(1)

  const [nextPageUrl, setNextPageUrl] = useState<string | null>(null)
  const [prevPageUrl, setPrevPageUrl] = useState<string | null>(null)

  const {
    data: smsTemplatedMessages,
    isError,
    isLoading,
  } = useQuery<PaginationType<SMSTemplatedType>>({
    queryKey: ["smsTemplatedMessages", defaultPage, page, search, zones],
    queryFn: () => getSMSTemplatedMessages(defaultPage, page, search, zones),
  })

  React.useEffect(() => {
    if (smsTemplatedMessages) {
      setNextPageUrl(smsTemplatedMessages.next)
      setPrevPageUrl(smsTemplatedMessages.previous)
    }
  }, [smsTemplatedMessages])

  const contentRef = React.useRef<HTMLDivElement>(null)
  const reactToPrintFn = useReactToPrint({ contentRef })

  return (
    <div className="space-y-4 p-4">
      <Header>SMS Templated Messages</Header>
      <div className="print:p-2" ref={contentRef}>
        <DataTable
          columns={smsTemplatedColumns}
          data={smsTemplatedMessages?.results ?? []}
          defaultPage={defaultPage}
          search={{
            //field: "zone",
            label: "SMS template",
            value: search,
            onChange: setSearch,
          }}
          isLoading={isLoading}
          isError={isError}
          setDefaultPage={setDefaultPage}
          nextPageUrl={nextPageUrl}
          prevPageUrl={prevPageUrl}
          page={page}
          setPage={setPage}
          totalCount={smsTemplatedMessages?.count}
          zones={zones}
          setZones={setZones}
        >
          {/* <div className="flex w-full justify-end">
          <Link
            to="/message-templates/sms/add"
            className={buttonVariants({ variant: "default" })}
          >
            <Icons.add className="size-4" /> Add SMS Templated Message
          </Link>
        </div> */}
          <div className="flex w-full justify-end">
            <AddSMSPage />
          </div>
          <Button onClick={() => reactToPrintFn()}>
            <Icons.download />
            Print SMS Templated Message
          </Button>
          <ExportOperationModal
            tableData={smsTemplatedMessages?.results ?? [{}]}
            fileName="SMS Templated Message"
            showExportModal={showExportModal}
            setShowExportModal={setShowExportModal}
          />
        </DataTable>
      </div>
    </div>
  )
}
